<nb-card>
  <nb-card-header>
    <div class="row">
      <div class="col-12 form-inline">
        <nb-form-field fullWidth>
          <nb-icon *ngIf="!isMoreInfo" nbPrefix icon="search-outline"></nb-icon>
          <nb-icon *ngIf="isMoreInfo" nbPrefix icon="person-outline"></nb-icon>
          <input
            type="text"
            nbInput
            fullWidth
            shape="semi-round"
            class="form-control"
            placeholder="{{
              isMoreInfo
                ? ('common.inputName' | translate)
                : ('common.strSearch' | translate)
            }}"
            [(ngModel)]="customer.fullName"
            (keydown.enter)="search()"
            #title
          />
        </nb-form-field>

        <button
          nbButton
          outline
          shape="semi-round"
          status="info"
          size="small"
          (click)="inputMore()"
        >
          <nb-icon
            [icon]="
              isMoreInfo
                ? 'arrow-ios-upward-outline'
                : 'arrow-ios-downward-outline'
            "
          ></nb-icon>
          <!-- <span>{{ isMoreInfo ? "Thu gọn" : "Tạo nhanh" }}</span> -->
        </button>

        <button
          *ngIf="!isMoreInfo"
          nbButton
          outline
          shape="semi-round"
          status="primary"
          size="small"
          (click)="onNew()"
          [disabled]="loading"
          [class.btn-pulse]="loading"
        >
          <span>{{ "buttons.create" | translate }}</span>
        </button>

        <button
          *ngIf="isMoreInfo"
          nbButton
          hero
          status="info"
          size="small"
          (click)="create()"
          [disabled]="
            submitted || !customer.fullName || customer.fullName.length === 0
          "
          [class.btn-pulse]="submitted"
        >
          <nb-icon nbPrefix icon="save-outline"></nb-icon>
          {{ "buttons.save" | translate }}
        </button>
      </div>
    </div>

    <div *ngIf="isMoreInfo" class="row">
      <div class="col-12 form-inline">
        <nb-form-field>
          <nb-icon nbPrefix icon="phone-call-outline"></nb-icon>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            placeholder="{{ 'common.mobile' | translate }}"
            [(ngModel)]="customer.mobile"
            (keydown.enter)="create()"
            #mobile
          />
        </nb-form-field>

        <nb-form-field fullWidth>
          <nb-icon nbPrefix icon="globe-outline"></nb-icon>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            placeholder="{{ 'common.address' | translate }}"
            [(ngModel)]="customer.address"
            (keydown.enter)="create()"
            #address
          />
        </nb-form-field>
      </div>
    </div>
  </nb-card-header>

  <!-- <nb-card-body>
    <div class="row">
      <div *ngFor="let item of display; let i = index" class="col-md-12">
        <ngx-view-customer
          [customer]="item"
          [mode]="mode"
          (onDelete)="onDelete($event)"
          (onEdit)="onEdit($event)"
          [users]="users"
          [productCategories]="productCategories"
        ></ngx-view-customer>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body> -->

  <nb-card-body>
    <div class="table-responsive">
      <table class="table align-items-center table-striped">
        <thead class="thead-light">
          <tr>
            <th scope="col">Họ tên</th>
            <th scope="col">Điện thoại</th>
            <th scope="col">Email</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let item of display
                | paginate : { itemsPerPage: itemsPerPage, currentPage: page };
              let i = index
            "
            [ngClass]="indexSelected === i ? 'bg-select' : ''"
          >
            <td>
              {{ item.fullName }}
            </td>
            <td>
              {{ item.mobile }}
            </td>
            <td>
              {{ item.email }}
            </td>

            <td>
              <button
                *ngIf="mode === 'customers'"
                nbButton
                ghost
                status="info"
                size="small"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="edit(item)"
              >
                <nb-icon icon="edit-2-outline"></nb-icon>
              </button>

              <button
                *ngIf="mode !== 'customers'"
                nbButton
                shape="round"
                outline
                status="success"
                size="small"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="selected(item)"
              >
                <nb-icon icon="checkmark-outline"></nb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="6">
              <strong class="text-hint"
                >Tổng số: {{ display.length | number }}</strong
              >
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <pagination-controls
      (pageChange)="pageChange($event)"
    ></pagination-controls>
  </nb-card-footer>
</nb-card>
